import { SubmissionError } from 'redux-form';
import fetch from '../../utils/fetch';
import { sanitizeDomainName } from './../../utils/helpers';


export function error(error) {
  return {type: 'CLIENT_CREATE_ERROR', error};
}

export function loading(loading) {
  return {type: 'CLIENT_CREATE_LOADING', loading};
}

export function success(created) {
  return {type: 'CLIENT_CREATE_SUCCESS', created};
}

export function create(values) {
  return (dispatch) => {
    dispatch(loading(true));

    //normalize values to the desired format before posting them
    let normalizedClientProducts = [];
    values.clientProducts.forEach((k, v)=>{
      if (k.name) {
        normalizedClientProducts.push( {'product': k['@id']} );
      }
    });
    values = {
      ...values,
      clientProducts: normalizedClientProducts,
      domainName: sanitizeDomainName(values.domainName)
    };


    return fetch('/clients', {method: 'POST', body: JSON.stringify(values)})
      .then(response => response.json())

      .then(data => {
        dispatch(loading(false));
        dispatch(success(data));
        // return data.statusText;
        return data;
      })
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });

    // fetch languages relationship
    // return fetch('/languages', {method: 'GET'})
    //   .then(response => {
    //     dispatch(loading(false));

    //     return response.json();
    //   })
    //   .then(data => dispatch(success(data)))
    //   .catch(e => {
    //     dispatch(loading(false));

    //     if (e instanceof SubmissionError) {
    //       dispatch(error(e.errors._error));
    //       throw e;
    //     }

    //     dispatch(error(e.message));
    //   });
  };
}



// WEBPACK FOOTER //
// ./src/actions/client/create.js